<template>
  <v-layout row wrap>
    <v-flex xs10>
      <v-textarea
        box
        :readonly="true"
        :value="text"
        class="mb-0"
        rows="10"
      ></v-textarea>
    </v-flex>
    <v-flex xs2 class="pl-1">
      <v-btn
        small
        color="primary"
        class="side-button copy-button"
        @click="textCopy"
        >Copy</v-btn
      >
      <v-btn
        small
        color="error"
        class="side-button clear-button"
        @click="textReset"
        >Reset</v-btn
      >
    </v-flex>
    <v-snackbar v-model="snackbar" :bottom="true" :timeout="3000"
      >コピーしました
      <v-btn color="pink" flat @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import moment from "moment";
import copy from "copy-to-clipboard";
moment.locale("ja");

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => {
    return {
      snackbar: null,
      inquiryText: ""
    };
  },
  computed: {
    text: {
      get() {
        let text = `${this.inquiryText}\n\n`;
        const fullWidthSpace = "　";
        Object.keys(this.value)
          .sort()
          .map(date => {
            text += `${moment(date).format(
              "M月D日(dd)"
            )}${fullWidthSpace}${this.value[date]
              .map(item => {
                return `${item.time}${item.suffix || ""}`;
              })
              .join(", ")}\n`;
          });
        return text;
      }
    }
  },
  created() {
    this.setInquiryText();
  },
  methods: {
    /**
     * クリップボードにコピー
     */
    textCopy() {
      copy(this.text);
      this.snackbar = true;
    },
    textReset() {
      this.$emit("input", {});
    },
    setInquiryText() {
      const params = decodeURI(location.search)
        .substring(1)
        .split("&")
        .map(p => p.split("="))
        .reduce((obj, e) => ({ ...obj, [e[0]]: e[1] }), {});
      this.inquiryText =
        params.hasOwnProperty("text") && params.text !== ""
          ? params.text
          : "以下で、お時間調整いかがでしょうか。";
    }
  }
};
</script>

<style scoped lang="scss">
/deep/ {
  .v-input__slot {
    margin-bottom: 0;
    textarea {
      margin-top: 0;
    }
  }
  .v-text-field__details {
    display: none;
  }
}
.side-button {
  width: 100%;
  min-width: 50%;
  height: 50%;
  margin: 0;
}
</style>
